import React from "react";
import { Link } from "react-router-dom";

import landingAsset from "../utils/assetPaths";

const Banner: React.FC = () => {
    return (
        <>
            <div className="flex flex-col items-center pb-16 mt-16 w-full px-4 md:px-14 ">
                <div
                    style={{
                        backgroundImage: `url(${landingAsset("pikaso.svg")})`,
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                    }}
                    className=" w-full md:h-[400px] p-6 rounded-[20px] bg-[#00000033] flex flex-col items-center justify-center"
                >
                    <p className=" text-[#FFFFFF] font-Manrope font-bold text-4xl md:text-[40px] text-center">
                        Join the SACA Community Today!
                    </p>
                    <p className=" text-center text-[#FFFFFF] font-medium text-xl mt-6 max-w-[900px]">
                        We're more than just a booking platform. Play, compete, and connect
                        with sports lovers like you—hassle-free. Sign up now and unlock the
                        full SACA experience!
                    </p>
                    <Link to="/sign-up">
                        <button className=" mt-[120px] py-3 px-[18px] bg-white rounded-[6px] font-Manrope text-[#317333] font-semibold text-[15px]">
                            Join SACA Today
                        </button>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default Banner;
